<template>
  <div class="invoices">
    <div class="invoices_header">
      <h1>Invoices</h1>
    </div>
    <div class="frameParent">
      <div class="frameGroup">
        <div class="dateWrapper">
          <div class="date">Date</div>
        </div>
        <div class="paymentMethod">Payment method</div>
        <div class="date">Amount</div>
        <div class="status">Status</div>
      </div>
      <img class="frameChild" alt="" src="Vector 78.svg" />
      <div class="frameContainer" v-for="invoice of invoices" v-bind:key="invoice.id">
        <div class="dateWrapper">
          <div class="date">{{invoice.createdAt.format('MM/DD/YYYY hh:mm:ss')}}</div>
        </div>
        <div class="paymentMethod">{{invoice.paymentMethodName}}</div>
        <div class="div2">${{invoice.total}}</div>
        <div class="status">{{invoice.billingStatus.name}}</div>
        <img class="dottedIcon" alt="" src="/static/img/dotted.svg" @click="toggleDropdown(invoice)" />
        <div v-if="invoice.dropdownOpen" class="invoiceDropdown">
          <button class="dropdownButton">View</button>
          <button class="dropdownButton">Download</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import { useLoginStore } from "../../../../../../stores/loginStore";
import InvoicesAPIService from "../../../../../../servicehandlers/InvoiceAPIService";

const invoiceAPIService = new InvoicesAPIService()
export default{
  name: "Invoices",
  data(){
    return {
      invoices: [],
      flightSchoolId: useLoginStore().getUser.flightSchoolId
    }
  },
  mounted(){
    this.getInvoices()

    document.addEventListener('click', this.handleClick);
  },

  methods: {
    getInvoices(){
      return invoiceAPIService.getInvoicesForFlightSchool(this.flightSchoolId, this.$router)
        .then(response => {
          for (let invoice of response){
            invoice.createdAt = dayjs(invoice.createdAt)
            invoice.dropdownOpen = false
          }
          this.invoices = response
        })
    },
    toggleDropdown(invoice){
      invoice.dropdownOpen = !invoice.dropdownOpen
    },
    handleClick(event){
      if (!event.target.closest('.invoiceDropdown') && !event.target.closest('.dottedIcon')) {
        for (let invoice of this.invoices) {
          invoice.dropdownOpen = false
        }
      }
    }
  }
};
</script>

<style lang="scss">
.invoiceDropdown{
  position: absolute;
  top: 0;
  right: 0;
  background-color: white;
  padding: 10px;
  border-radius: 10px;
  z-index: 5;
  display: flex;
  flex-direction: column;
  gap: 5px;
}
.dropdownButton{
  background-color: #cfcfcf;
  padding: 5px 10px;
  color: #404040;
}
.invoices {
  width: 100%;
  max-width: 780px;

  .invoices_header {
    h1 {
      color: #404040;
      font-size: 35px;
      font-weight: 700;
      margin-bottom: 20px;
      overflow: hidden;
      text-overflow: ellipsis;
      font-family: Helvetica, Arial, sans-serif;
    }
  }

  .frameParent {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    padding: 20px 0px;
    gap: 15px;
    text-align: left;
    font-size: 15px;
    color: #404040;
    font-family: Helvetica, Arial, sans-serif;
  }

  .frameGroup {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 40px;
    font-size: 13px;
    color: rgba(64, 64, 64, 0.75);
  }

  .frameContainer {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 40px;
    position: relative;
  }

  .dateWrapper {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    width: 200px;
  }

  .date {
    position: relative;
  }

  .paymentMethod,
  .status,
  .div2 {
    position: relative;
    flex-shrink: 0;
  }

  .paymentMethod {
    width: 115px;
  }

  .status {
    width: 45px;
  }

  .div2 {
    width: 52px;
  }

  .frameChild {
    position: relative;
    max-width: 100%;
    overflow: hidden;
    max-height: 100%;
    align-self: stretch;
  }

  .dottedIcon {
    width: 16px;
    height: 16px;
    cursor: pointer;
  }
}
</style>
